import { DeskingOfferHistoryInfo } from '@upstart/harmony/lib/legos/deskingTypes';
import { VersionSnapshots } from 'components/DeskingEditor/types';
import { Record } from 'immutable';
import * as types from './actionTypes';

export interface PencilHistoryState {
  pencilHistoryOpened: boolean;
  offerHistory: DeskingOfferHistoryInfo[] | null;
  versionSnapshots: VersionSnapshots | null;
  fetchingOfferHistory: boolean;
  fetchingVersionSnapshots: boolean;
  restoringVersion: boolean;
  fetchingOfferHistoryError: unknown;
  fetchingVersionSnapshotsError: unknown;
  restoringVersionError: unknown;
}

const requestReducerState = Record({
  pencilHistoryOpened: false,
  offerHistory: null,
  versionSnapshots: null,
  fetchingOfferHistory: false,
  fetchingVersionSnapshots: false,
  restoringVersion: false,
  fetchingOfferHistoryError: null,
  fetchingVersionSnapshotsError: null,
  restoringVersionError: null,
});

export default (state = requestReducerState(), action: any) => {
  const { type, payload } = action;
  switch (type) {
    case types.OPEN_PENCIL_HISTORY:
      return state.set('pencilHistoryOpened', true);
    case types.CLOSE_PENCIL_HISTORY:
      return state
        .set('pencilHistoryOpened', false)
        .set('versionSnapshots', null)
        .set('offerHistory', null);
    case types.OFFERHISTORY_REQUEST:
      return state
        .set('fetchingOfferHistoryError', null)
        .set('fetchingOfferHistory', true);
    case types.VERSIONSNAPSHOTS_REQUEST:
      return state
        .set('fetchingVersionSnapshotsError', null)
        .set('fetchingVersionSnapshots', true);
    case types.RESTOREVERSION_REQUEST:
      return state
        .set('restoringVersionError', null)
        .set('restoringVersion', true);
    case types.OFFERHISTORY_SUCCESS:
      return state
        .set('fetchingOfferHistory', false)
        .set('offerHistory', payload);
    case types.VERSIONSNAPSHOTS_SUCCESS:
      return state
        .set('fetchingVersionSnapshots', false)
        .set('versionSnapshots', payload);
    case types.RESTOREVERSION_SUCCESS:
      return state.set('restoringVersion', false);
    case types.OFFERHISTORY_FAILURE:
      return state
        .set('fetchingOfferHistory', false)
        .set('fetchingOfferHistoryError', action.payload);
    case types.VERSIONSNAPSHOTS_FAILURE:
      return state
        .set('fetchingVersionSnapshots', false)
        .set('fetchingVersionSnapshotsError', action.payload);
    case types.RESTOREVERSION_FAILURE:
      return state
        .set('restoringVersion', false)
        .set('restoringVersionError', action.payload);
    default:
      return state;
  }
};
